import script from "./PayoutDetailsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./PayoutDetailsView.vue?vue&type=script&lang=ts&setup=true"

import "./PayoutDetailsView.vue?vue&type=style&index=0&id=70c0e13e&lang=scss"

const __exports__ = script;

export default __exports__